import React from 'react';
import PropTypes from 'prop-types';
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import DataTableFilter from './DataTableFilter';
import useFilterDataTable from './hooks/useFilterDataTable';
import Spinner from 'react-bootstrap/Spinner';

const customStyles = {
    table: {
        style: {
            border: '1px solid #F5F7FA',
        },
    },
    headCells: {
        style: {
            fontWeight: 'bold',
            padding: '15px',
        },
    },
};

function ReactDatatableComponent({ columns, rows }) {
    const { isLoading } = useSelector((state) => state.loading);

    const [filterText, setFilterText, resetPaginationToggle, setResetPaginationToggle] = useFilterDataTable();

    const filteredItems = rows.filter(
        (item) => JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !== -1,
    );

    const subHeaderComponent = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <DataTableFilter
                onFilter={(e) => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);

    return (
        <DataTable
            columns={columns}
            data={filteredItems}
            striped
            pagination
            paginationPerPage="10"
            persistTableHead
            progressPending={isLoading} //spinning icon will trigger when isLoading = 1
            noDataComponent={<h3 className="m-3">No data...</h3>}
            progressComponent={
                <Spinner
                    animation="border"
                    role="status"
                >
                    <span className="visually-hidden"></span>
                </Spinner>
            }
            customStyles={customStyles}
            subHeader
            subHeaderComponent={subHeaderComponent}
            paginationResetDefaultPage={resetPaginationToggle}
        />
    );
}

export default ReactDatatableComponent;

ReactDatatableComponent.propTypes = {
    columns: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
};
